module.exports = __webpack_public_path__ + "media/images/frontend/logo-76715425b022a6675168741ed67fc62f.svg";